export default {
  LOGIN: '/showScreenLogin/showLogin',
  VERIFY_LOGIN: '/showScreenLogin/login', // 验证用户是否能登录
  SEARCH_USER: '/showScreenLogin/searchUser',

  LOGOUT: '/showScreenLogin/logout',
}
